import apiService from '@/state/services/Api'
import orderBy from 'lodash-es/orderBy'
import _cloneDeep from 'lodash-es/cloneDeep'

const companies = {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list(state) {
      return orderBy(state.list, [company => company.name.toLowerCase()], ['asc'])
    },
    getById: state => id => {
      return _cloneDeep(state.list.find(e => e.id === id))
    },
    getByName: state => name => {
      name = name.trim()
      return _cloneDeep(state.list.find(e => e.name === name))
    },
    crmAccounts(state) {
      return state.list.reduce((acc, company) => [...acc, company.customer_account], [])
    },
    // Services in auth module
    getServices(state, getters, rootState, rootGetters) {
      return id => {
        if (!id) {
          return []
        }
        const company = state.list.find(c => +c.id === +id)
        return company.services.map(serviceId =>
          rootGetters['auth/services'].find(service => service.id === serviceId)
        )
      }
    },
    permissionsById(state, getters, rootState, rootGetters) {
      return id => {
        const perms = rootGetters['auth/userPermissions'].reduce(
          (acc, key) => [...acc, {id: Object.keys(key)[0], label: Object.entries(key)[0][1]}],
          []
        )
        return perms
      }
    },
  },
  mutations: {
    SET_COMPANIES(state, payload) {
      state.list = payload
    },

    UPDATE_COMPANY(state, payload) {
      const foundIndex = state.list.findIndex(company => company.id === payload.id)
      state.list.splice(foundIndex, 1)
      state.list.push(payload)
    },

    ACTIVATE_COMPANY(state, payload) {
      const foundIndex = state.list.findIndex(company => company.id === payload)
      state.list[foundIndex].is_active = true
    },

    CREATE_COMPANY(state, payload) {
      state.list.push(payload)
    },

    DELETE_COMPANY(state, id) {
      state.list = state.list.filter(company => company.id !== id)
    },
  },
  actions: {
    importCrm({state, commit}, payload = {}) {
      return apiService.post(`companies/crm_search/`, payload).then(data => {
        return data
      })
    },

    createFromCrm(context, payload) {
      return apiService.post(`companies/crm_import/`, payload).then(data => {
        context.commit('CREATE_COMPANY', data)
        return data
      })
    },

    getAll({state, commit}) {
      return apiService.fetch(`companies/?no_page=true`).then(data => {
        commit('SET_COMPANIES', data)
        return data
      })
    },

    getCompanyById({commit}, companyId) {
      return apiService.fetch(`companies/${companyId}`).then(data => {
        return data
      })
    },

    create(context, payload) {
      return apiService.post(`companies/`, payload).then(data => {
        context.commit('CREATE_COMPANY', data)
        return data
      })
    },

    update(context, payload) {
      const {id, area, ...body} = payload
      if (body.mailing_list) {
        body.mailing_list = body.mailing_list.split(',').filter(item => item.trim().length > 0)
      } else {
        body.mailing_list = []
      }
      return apiService.patch(`companies/${id}/`, body).then(data => {
        context.commit('UPDATE_COMPANY', data)
        return data
      })
    },

    checkActive(context, {id}) {
      return apiService.get(`companies/${id}/activate/`).then(data => {
        return data
      })
    },

    activate(context, payload) {
      const {id, ...body} = payload
      return apiService
        .post(`companies/${id}/activate/`, body)
        .then(data => {
          console.log(data)
          context.commit('ACTIVATE_COMPANY', id)
          return data
        })
        .catch(error => {
          console.log('hello', error)
          throw error
        })
    },

    delete(context, {id}) {
      return apiService.delete(`companies/${id}/`).then(data => {
        context.commit('DELETE_COMPANY', id)
        return data
      })
    },

    // WIP
    createSubscription(context, {id}) {
      console.log('Creating subscription for company:', id)
      return apiService
        .post(`companies/${id}/subscriptions`, {plan: 'mex', spec: {tablet_quota: 5}})
        .then(data => data)
    },
  },
}

export default companies
